const normalizeItem = ({id, acceptedDate: label}) => ({id, label});

export default (options) => options.map(normalizeItem).sort((a, b) => b.label.localeCompare(a.label));
